export default __webpack_public_path__ + "static/GT-Super-Display-Medium-a5d35187907604394bad26fcc77f01df.woff";